import { HttpError } from '@magiczne/http-client'
import { set } from 'vue'
import { defineStore } from 'pinia'

import PagesRepository from '@/app/repositories/pages-repository'
import NotFoundError from '@/common/errors/not-found-error'
import { Page } from '@/common/models/data/dashboard/page'

const usePagesStore = defineStore('pages', {
    state: () => ({
        pages: {} as Record<string, Page>
    }),
    actions: {
        async loadPage (name: string): Promise<void> {
            try {
                this.setPage(await PagesRepository.byName(name))
            } catch (e) {
                if (e instanceof HttpError && e.response?.status === 404) {
                    throw new NotFoundError()
                }
            }
        },
        setPage (page: Page): void {
            set(this.pages, page.page, page)
        }
    },
    getters: {
        page: (state) => {
            return (name: string): Page => {
                return state.pages[name] ?? new Page()
            }
        }
    }
})

export {
    usePagesStore
}
